import { Modal } from 'react-bootstrap';

import classes from './HowGoShareWorksModal.module.css';
import { Calendar, Truck, X } from 'react-feather';
import { Armchair } from 'lucide-react';

const HowGoShareWorksModal = (props) => {
	const { goShareModal, setGoShareModal } = props;
	return (
		<>
			<Modal show={goShareModal} onHide={() => setGoShareModal(false)}>
				<div className={classes.main}>
					<X
						onClick={() => setGoShareModal(false)}
						strikeWidth={1}
						className={classes.closeIcon}
					/>
					<h3 className={classes.title}> Local delivery with GoShare</h3>
					<img
						className={classes.deliveryPic}
						alt={'local on demand delivery available on Kashew'}
						src={
							'https://ik.imagekit.io/kuj9zqlrx0or/Static/goShareDelivers.jpg?tr=h-400'
						}
					/>

					<div className={classes.deliverySpec}>
						<Armchair className={classes.icon} />
						<h6 className={classes.infoText}>
							Send a purchase request or offer for the item, and tell us your
							preferred delivery time.
						</h6>
					</div>

					<div className={classes.deliverySpec}>
						<Calendar className={classes.icon} />
						<h6 className={classes.infoText}>
							We&apos;ll make sure that the seller is able to fullfill the
							delivery at your desired time. If they can&apos;t for some reason,
							you can easily reschedule through our system.
						</h6>
					</div>

					<div className={classes.deliverySpec}>
						<Truck className={classes.icon} />
						<h6 className={classes.infoText}>
							GoShare picks up the item and brings it all the way to it&apos;s
							new spot in your home.
						</h6>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default HowGoShareWorksModal;
